import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";

// Vertical animated thread that draws itself as the user scrolls the page.
export const CentralThread = () => {
  const { scrollYProgress } = useScroll();
  const scaleY = useSpring(scrollYProgress, {
    stiffness: 90,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-y-0 left-1/2 z-[2] hidden -translate-x-1/2 md:block"
      style={{ width: 1 }}
    >
      <motion.div
        style={{
          scaleY,
          transformOrigin: "top",
          height: "100%",
          background:
            "linear-gradient(180deg, transparent, rgba(201,168,124,0.5) 12%, rgba(201,168,124,0.5) 88%, transparent)",
        }}
      />
    </div>
  );
};

export default CentralThread;
